module.exports = __webpack_public_path__ + "static/media/granchester2.e5b51c0f.jpg";